/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface RecruitInterviewResult { 
    id?: string;
    recruit_result_option_id?: string;
    recruit_round_id?: string;
    comment?: string;
    submitted?: boolean;
    created_at?: Date;
    created_by?: string;
    modified_at?: Date;
    modified_by?: string;
}